module.exports = __webpack_public_path__ + "static/media/00.3949c389.webp";